import React, { useState, useEffect, useRef } from 'react';
import '../contabildade.css';
import axios from 'axios';
import { DatePicker, Button, Card,Select, Table, Space, Typography} from 'antd';
import ReactToPrint from 'react-to-print';
import ReactToExcel from 'react-html-table-to-excel';
import { ComponentToPrint } from './Print';
import {  PrinterOutlined, FileExcelOutlined, ClockCircleOutlined, EnvironmentOutlined, CreditCardOutlined } from '@ant-design/icons';
import moment from 'moment';
import vatImage from './images/vat (1).png';
import gasPumpImage from './images/gas-pump.png';
import flameImage from './images/flame.png';
import gasImage from './images/gas.png';
import taxImage from './images/tax.png';
import * as XLSX from 'xlsx';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title } = Typography;

function ContaRela() {
  const [error, setError] = useState();
  const printRelaResumos = useRef();
  const [dates, setDates] = useState([null, null]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [zone, setZone] = useState('');

    const SearchDados=(dates_s)=>{
  
      console.log('datas',dates_s)
        axios({
            method:"get",
            url:`${localStorage.getItem('url')}/web/ComprasFiltradas/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            params:{
                datas: dates_s,
            }
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( response=>{
            setData(response.data);
          console.log("dsdsdsdsdsd")
          console.log(response.data)
          setFilteredData(response.data);
          
          }
       
           ).catch(e=>{
            setError(e.message );
        })
    

    }
 
 




    const handleDateChange = (dates) => {
      if (dates && dates.length === 2) {
        const startDate = dates[0].startOf('day'); // Define a hora como 00:00
        const endDate = dates[1].endOf('day'); // Define a hora como 23:59
    
        console.log('Data Inicial:', startDate.format('YYYY-MM-DD HH:mm'));
        console.log('Data Final:', endDate.format('YYYY-MM-DD HH:mm'));
    
        const updatedDates = [startDate, endDate]; // Atualize o array dates com as horas ajustadas
    
        setDates(updatedDates); // Atualize o estado com as novas datas
        filterData(updatedDates, paymentMethod, zone); // Passe as datas atualizadas para o filtro
        if (updatedDates.length === 2) {
          SearchDados(updatedDates); // Use as datas atualizadas na função de busca
        }
      } else {
        setDates(dates); // Caso o array de dates não esteja completo, mantenha o valor original
      }
    };
    

  const handlePaymentChange = (value) => {
    setPaymentMethod(value);
    filterData(dates, value, zone);
  };

  const handleZoneChange = (value) => {
    setZone(value);
    filterData(dates, paymentMethod, value);
  };


  const filterData = (dates, paymentMethod, zone) => {
    let filtered = data;
    if (dates && dates[0] && dates[1]) {
      filtered = filtered.filter(item => {
        const date = new Date(item.data_de_compra);
        return date >= dates[0] && date <= dates[1];
      });
    }
    if (paymentMethod) {
      filtered = filtered.filter(item => item.metodo === paymentMethod);
    }
    if (zone) {
      filtered = filtered.filter(item => item.morada.toLowerCase().includes(zone.toLowerCase()));
    }
    setFilteredData(filtered);
  };

  const columns = [
    { title: 'Data', dataIndex: 'data_de_compra', key: 'data_de_compra' },
    { title: 'ID.Cliente', dataIndex: 'idCliente', key: 'idCliente' },
    { title: 'ID.Contador', dataIndex: 'idContador', key: 'idContador' },
    { title: 'ID.Token', dataIndex: 'idToken', key: 'idToken' },
    { title: 'Canal de Venda', dataIndex: 'metodo', key: 'metodo' },
    { title: 'IVA', dataIndex: 'iva', key: 'iva', render: (text) => parseFloat(text).toFixed(6) },
    { title: 'TSC', dataIndex: 'tsc', key: 'tsc', render: (text) => parseFloat(text).toFixed(6) },
    { title: 'm3', dataIndex: 'metroscubicos', key: 'metroscubicos', render: (text) => parseFloat(text).toFixed(2) },
    {
      title: 'Valor Líquido',
      dataIndex: 'valor_pago',
      key: 'valor_pago',
      render: (text, record) => {
        const valorPago = parseFloat(record.valor_pago);
        const tsc = parseFloat(record.tsc);
        const taxaFixa = parseFloat(record.taxa_fixa);
        const iva = parseFloat(record.iva);
        const v =valorPago-tsc-iva

        // Calcular valor líquido
        return v
      }
    },
    {
      title: 'Valor Bruto',
      dataIndex: 'valor_pago',
      key: 'valor_bruto',
      render: (text, record) => {
        const valorPago = parseFloat(record.valor_pago);
        const iva = parseFloat(record.iva);
        const tsc = parseFloat(record.tsc);
        const taxaFixa = parseFloat(record.taxa_fixa);
        const v=valorPago+ taxaFixa*1.16
          return v
      }
    },
    { title: 'Taxa Fixa', dataIndex: 'taxa_fixa', key: 'taxa_fixa' }
  ];

  const exportToExcel = () => {
    const exportData = filteredData.map(item => {
      const valorPago = parseFloat(item.valor_pago);
      const tsc = parseFloat(item.tsc);
      const taxaFixa = parseFloat(item.taxa_fixa);
      const iva = parseFloat(item.iva);

      const valorLiquido = (valorPago - tsc - iva);
      const valorBruto = valorPago + taxaFixa*1.16;

      return {
        ...item,
        valor_liquido: valorLiquido.toFixed(2),
        valor_bruto: valorBruto.toFixed(2),
      };
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Clientes');

    XLSX.writeFile(wb, 'Compras.xlsx');
  };
  
  const calculateSum = (field) => {
    return filteredData.reduce((sum, item) => {
      return sum + (parseFloat(item[field]) || 0);
    }, 0);
  };
  const calculateSumESP = (type) => {
    return filteredData.reduce((sum, item) => {
      const valorPago = parseFloat(item.valor_pago);
      const iva = parseFloat(item.iva);
      const tsc = parseFloat(item.tsc);
      const taxaFixa = parseFloat(item.taxa_fixa);
  
      let value = 0;
  
      if (type === 'liquido') {
        // Check if valor_pago is an "integer" (considering numbers like 100.00 as integers)
          value = valorPago - tsc  - iva;
       } else if (type === 'bruto') {
        // Check if valor_pago is an "integer" (considering numbers like 100.00 as integers)
       value=valorPago+taxaFixa*1.16
      }
  
      return sum + (parseFloat(value) || 0);
    }, 0).toFixed(2);
  };
  // Cálculo dos totais
  const totalIVA = calculateSum('iva').toFixed(2);
  const totalTSC = calculateSum('tsc').toFixed(2);
  const totalTF = calculateSum('taxa_fixa').toFixed(2);
  const totalGas = calculateSum('metroscubicos').toFixed(2);
  const totalLiquido = calculateSumESP('liquido');
  const totalBruto = calculateSumESP('bruto');

  // Condicional para totalLiquido
  


  return (
    <div className='Contabilidade'>
       <div className='Totais'>
      <Space direction="horizontal" size="large" align="center">
        <Card title="IVA" bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center' }}>

             {totalIVA} Mzn
          </div>
        </Card>
        <Card title="TAXA FIXA" bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center' }}>

             {totalTF} Mzn
          </div>
        </Card>
        <Card title="TSC" bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
    
            {totalTSC} Mzn
          </div>
        </Card>
        <Card title="Total Líquido" bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
     
             {totalLiquido} 
          </div>
        </Card>
        <Card title="Total Gas" bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
  
             {totalGas} m3
          </div>
        </Card>
        <Card title="Total Bruto" bordered={false}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
             {totalBruto} Mzn
          </div>
        </Card>
      </Space>
      </div>
      <div className='filters'>
        <Space>
          <ClockCircleOutlined />
          <div>
            <div>Período</div>
            <RangePicker onChange={handleDateChange} />
          </div>

          <CreditCardOutlined />
          <div>
            <div>Método de Pagamento</div>
            <Select defaultValue="" onChange={handlePaymentChange} style={{ width: 150 }}>
              <Option value="">Nenhum</Option>
              <Option value="Mpesa">M-PESA</Option>
              <Option value="emola">E-MOLA</Option>
              <Option value="RecargaAKI">RECARGAAKI</Option>
           
            </Select>
          </div>

          <EnvironmentOutlined />
          <div>
            <div>Zona</div>
            <Select defaultValue="" onChange={handleZoneChange} style={{ width: 150 }}>
              <Option value="">Nenhum</Option>
              <Option value="aeroporto">Aeroporto</Option>
              <Option value="junho">25 de Junho</Option>
              <Option value="coop">Coop PH5</Option>
              <Option value="coop">Coop PH6</Option>
              <Option value="Munhuana">Munhuana</Option>
            </Select>
          </div>

          <PrinterOutlined />
          <ReactToPrint
            trigger={() => <Button>Imprimir</Button>}
            content={() => printRelaResumos.current}
          />

          <FileExcelOutlined />
          <Button onClick={exportToExcel}>Exportar para Excel</Button>
        </Space>
      </div>

      <div >
        <Table
          
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          pagination={{ pageSize: 2 }}

        />
      </div>



      <ComponentToPrint ref={printRelaResumos}>
        <div className='Relatorios'>
       
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={false}
            rowKey="id"
          />
        </div>
      </ComponentToPrint>
    </div>
  );
}

export default ContaRela;
